class ConfigurableBannerSection extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-banner-track]');
    if (!this.track || !this.track.classList.contains('configurable-banner-section__items--carousel')) return;

    this.onPointerDown = this.startDrag.bind(this);
    this.onPointerMove = this.drag.bind(this);
    this.onPointerUp = this.endDrag.bind(this);
    this.onClick = this.stopClickAfterDrag.bind(this);

    this.track.addEventListener('pointerdown', this.onPointerDown);
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.onPointerUp);
    this.track.addEventListener('pointercancel', this.onPointerUp);
    this.track.addEventListener('lostpointercapture', this.onPointerUp);
    this.track.addEventListener('click', this.onClick, true);
  }

  disconnectedCallback() {
    this.track?.removeEventListener('pointerdown', this.onPointerDown);
    this.track?.removeEventListener('pointermove', this.onPointerMove);
    this.track?.removeEventListener('pointerup', this.onPointerUp);
    this.track?.removeEventListener('pointercancel', this.onPointerUp);
    this.track?.removeEventListener('lostpointercapture', this.onPointerUp);
    this.track?.removeEventListener('click', this.onClick, true);
  }

  startDrag(event) {
    if (event.pointerType === 'touch' || (event.pointerType === 'mouse' && event.button !== 0)) return;

    this.isDragging = true;
    this.hasDragged = false;
    this.dragStartX = event.clientX;
    this.dragStartScrollLeft = this.track.scrollLeft;
    this.track.classList.add('is-dragging');
    this.track.setPointerCapture(event.pointerId);
  }

  drag(event) {
    if (!this.isDragging) return;

    const deltaX = event.clientX - this.dragStartX;

    if (Math.abs(deltaX) > 3) {
      this.hasDragged = true;
      event.preventDefault();
      this.track.scrollLeft = this.dragStartScrollLeft - deltaX;
    }
  }

  endDrag(event) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.track.classList.remove('is-dragging');

    if (this.track.hasPointerCapture?.(event.pointerId)) {
      this.track.releasePointerCapture(event.pointerId);
    }
  }

  stopClickAfterDrag(event) {
    if (!this.hasDragged) return;

    event.preventDefault();
    event.stopPropagation();
    this.hasDragged = false;
  }
}

if (!customElements.get('configurable-banner-section')) {
  customElements.define('configurable-banner-section', ConfigurableBannerSection);
}
